module.exports =  {
  TITLE: {
  default: 'Tìm Kiếm Khách Sạn|Hàng ngàn khách sạn trực tuyến tại châu Á để đặt phòng',
  detail: '|Đặt Phòng Khách Sạn',
  },
  hotel: {
    // 酒店搜索改版新增翻译--英文
   ROOMS: 'Phòng',
  GUESTS: 'Khách',
  CHECK_IN_NUM: 'Khách',
  PREFIX_ADULTS: '',
  SUFFIX_ADULT: 'Người lớn',
  SUFFIX_ADULTS: 'Người lớn',
  PREFIX_CHILDREN: '',
  SUFFIX_CHILD: 'Trẻ em',
  SUFFIX_CHILDREN: 'Trẻ em',
  CHILD_AGE: 'Tuổi của trẻ',
  NO_MATCH_TIPS: 'Loại phòng dưới đây không phù hợp với số phòng và khách bạn đã chọn.',

  Book_Hotel: 'Đặt phòng khách sạn',
  Select_your_destination: 'Chọn điểm đến của bạn',
  Please_enter_your_destination: 'Vui lòng nhập điểm đến/khách sạn của bạn',
  Booked_up: 'Hết phòng',
  Hotel_description: 'Mô tả khách sạn',
  Check_in_date: 'Ngày nhận phòng',
  Check_out_date: 'Ngày trả phòng',
  Sold_out: 'Hết phòng',
  Non_refundable: 'Không hoàn lại',
  reserve: 'Đặt',
  Pay_Online: 'Thanh toán trực tuyến',
  Only_rooms_left_before: 'Chỉ còn ',
  Only_rooms_left_after: ' phòng',
  Cancellation_Policy: 'Chính sách hủy',
  See_all_prices_before: 'Xem tất cả ',
  See_all_prices_after: 'giá',
  Estimated_time_of_arrival: 'Thời gian đến dự kiến',
  make_your_schedule_well_planned: 'Thời gian theo múi giờ địa phương, hãy lên kế hoạch chu đáo và đến đúng giờ.',
  Hotel_Not_Found: 'Không tìm thấy khách sạn',
  Please_change_your_search: 'Vui lòng thay đổi tìm kiếm của bạn',
  Submit_an_application: 'Gửi đơn',
  Hotel_Confirmation: 'Xác nhận đặt phòng',
  Many_Night_Stay_before: '',
  Many_Night_Stay_after: '-Đêm ở',
  Hotel_Booking_Number: 'Số đặt phòng khách sạn',
  Online_Payment: 'Thanh toán trực tuyến',
  The_guest_Room_before: 'Phòng của khách [',
  The_guest_Room_after: ']',
  Contact_number: 'Số liên lạc',
  Bring_all_valid_IDs: 'Vui lòng mang theo tất cả các chứng minh nhân dân hợp lệ của tất cả khách khi nhận phòng.',
  Hotels_Found_before: '',
  Hotels_Found_after: 'Khách sạn được tìm thấy',
  Hotels_Presented_before: '',
  Hotels_Presented_center: 'Khách sạn được giới thiệu (',
  Hotels_Presented_after: 'tổng cộng)',
  Please_change_the_dates: 'Phòng không có sẵn vào ngày bạn chọn, vui lòng thay đổi ngày.',
  Login: 'Đăng nhập vào ứng dụng để đặt khách sạn',
  Nights_in_total_before: '',
  Nights_in_total_after: 'Đêm tổng cộng',
  Location: 'Địa điểm',
  Pictures: 'Hình ảnh',
  Description: 'Mô tả',
  Policy: 'Chính sách',
  Check_in_and_check_out_time: 'Thời gian nhận và trả phòng',
  Check_in_and_Check_out_before: 'Nhận phòng: sau ',
  Check_in_and_Check_out_center: 'Trả phòng: trước ',
  Check_in_and_Check_out_after: '',
  Check_in_time: 'Thời gian nhận phòng',
  Check_out_time: 'Thời gian trả phòng',
  Hotel_Information: 'Thông tin cơ bản',
  Opening_Date: 'Ngày khai trương',
  Renovation_Date: 'Ngày sửa chữa',
  Facility_Service: 'Tiện ích & Dịch vụ',
  Payment_methods: 'Phương thức thanh toán được chấp nhận bởi khách sạn',
  Hotel_Address: 'Địa chỉ khách sạn',
  Pay_online: 'Thanh toán trực tuyến',
  Pay_offline: 'Thanh toán khi đến',
  Night_stay_before: '',
  Night_stay_after: '-Đêm ở,',
  Rooms_total_before: 'Số phòng',
  Rooms_total_after: 'tổng cộng',
  Guest_name_must_be_provided: 'Phải cung cấp đầy đủ tên của khách.',
  Please_fill_in_your_contact_number: 'Vui lòng điền số điện thoại liên lạc của bạn',
  Select_estimated_time_of_arrival: 'Chọn thời gian đến dự kiến',
  Number_of_Rooms: 'Số phòng',
  Maximum_guests_per_room_before: 'Tối đa ',
  Maximum_guests_per_room_after: ' khách mỗi phòng',
  Many_Rooms: ' Phòng',
  Service_Fee_Included: '(Thuế & Phí Dịch vụ đã bao gồm)',
  Last_Name: 'Họ',
  First_Name: 'Tên ',
  Room: 'Phòng',
  Additional_Tax: 'Thuế bổ sung',
  Please_inform_the_hotel: 'Nếu bạn sẽ đến sau thời gian đến dự kiến, vui lòng thông báo cho khách sạn trước.',
  Please_inform_the_hotel_first: 'Đến khách sạn sau thời gian đến dự kiến mà không liên hệ trước với khách sạn sẽ ảnh hưởng đến sự có sẵn của phòng và bữa tối. Vui lòng thông báo cho khách sạn trước để xác nhận sự có sẵn trong tình huống như vậy.',
  Booking_Cancellation: 'Hủy đặt phòng',
  Reason_of_Cancellation: 'Lý do hủy',
  Incorrect_Information_Filled: 'Thông tin không chính xác',
  Itinerary_Changed: 'Lịch trình đã thay đổi',
  Lower_price_on_other_APP: 'Giá thấp hơn trên ứng dụng khác',
  Low_quality_hotel: 'Khách sạn chất lượng kém',
  Book_at_a_lower_price: 'Đặt với giá thấp hơn tại quầy đăng ký',
  Other: 'Khác',
  Please_write_your_reason: 'Vui lòng viết lý do của bạn',
  After_cancellation_done: 'Sau khi hủy xong, thanh toán sẽ được hoàn lại cho người thanh toán ban đầu trong vòng 3 ngày làm việc.',
  How_to_fill_in_the_guest_name: 'Cách điền tên của khách',
  It_should_be_exactly_the_same: 'Vui lòng cung cấp tên khách bằng chữ tiếng Anh cho việc đặt phòng khách sạn. Nó phải hoàn toàn giống với chứng minh được trình bày khi bạn nhận phòng.',
  How_to_fill_in_a_Chinese_name: 'Cách điền tên tiếng Trung:',
  How_to_fill_in_a_English_name: 'Cách điền tên tiếng Anh',
  For_example: 'Ví dụ: Nếu tên tiếng Trung của bạn là “韩梅梅”, họ là "Han", tên là "Meimei".',
  No_specical_characters: 'Không điền bất kỳ số hoặc ký tự đặc biệt nào.',
  Name_rule_first: 'Họ đến trước, tên đến sau, và nếu có tên đệm, nó được đặt sau hai tên. ',
  Name_rule_second: 'Ví dụ: Green / Jim Stephanie',
  Details: 'Chi tiết',
  Pay_now: 'Thanh toán ngay',
  Hotel: 'Khách sạn',
  Check_in: 'Nhận phòng',
  Car: 'Xe hơi',
  All_bookings: 'Tất cả đặt phòng',
  All: 'Tất cả',
  PROMPT: 'Chú ý',

     Search: 'Tìm kiếm',
  COST_DESCRIPTION: 'Chi tiết giá',
  TOTAL: 'Tổng cộng',
  SEE_ORDER_INFO_TO: 'Thanh toán',
  KONW: 'Đã hiểu',
  BOOKING_INFORMATION: 'Thông tin quan trọng',
  Book_Now: 'Thanh toán ngay',
  MAP: 'Bản đồ',
  CONTACT_INFORMATION: 'Thông tin liên hệ',
  LOADING: 'Đang tải...',
  SORT_FILTER: 'Sắp xếp/ Lọc',
  SCREENING: 'Lọc',
  SEQUENCE: 'Sắp xếp',
  PHONE_ASK: 'Gọi cho chúng tôi',
  ABOVE: '',
  SUBMINT_ORDER: 'Gửi',
  OK: 'Đồng ý',
  Order_detail: 'Chi tiết đặt phòng',
  BOOKING_INFO: 'Thông tin đặt phòng',
  PAYMENT_AMOUNT: 'Số tiền thanh toán',
  Order_time: 'Thời gian đặt phòng',
  ORDER_NUMBERS: 'Số đặt phòng',
  PAY_TYPE: 'Phương thức thanh toán',
  BALANCE: 'Số dư',
  CURRENT_BALANCE_BEGIN: 'Số dư',
  OVERPLUS_BALANCE_BEGIN: 'Còn lại',
  OTHER_PAYMENT: 'Các phương thức thanh toán khác',
  Unionpay: 'UnionPay',
  Wechatpay: 'WeChat Payment',
  Alipay: 'Alipay',
  AGREE_SERVICE_AGREEMENT_BEFORE: 'Bấm vào “Thanh toán ngay” có nghĩa là bạn đồng ý với ',
  AGREE_SERVICE_AGREEMENT_AFTER: '',
  SERVICE_AGREEMENT: '《Hợp đồng Dịch vụ》 của Baigolf',
  PAYMENT_ORDER: 'Thanh toán đặt phòng',
  Total_pay: 'Số tiền đến hạn',
  PAY_SUCCESS: 'Thanh toán thành công',
  CHECK_THE_ORDER: 'Kiểm tra đơn đặt phòng',
  BACK_TO_INDEX: 'Quay lại trang chính',
  CANCEL: 'Hủy',
  RECOMMED: 'Đề xuất',
  PRICE: 'Giá',
  HIGH: 'Cao',
  LOW: 'Thấp',
  RESET: 'Đặt lại',
  SELECT_TIME: 'Chọn ngày',
  Hotel_guest: 'Khách',
  Select: 'Vui lòng chọn',
  Emial_address: 'Vui lòng nhập địa chỉ email',
  Booking_explan: 'Thông tin đặt phòng',
  VIEW_MORE: 'Xem thêm',
  COLLAPSE: 'Ẩn',
  Week: '',
  Month: '',
  TOURISM_CHECK_IN_HOTEL: 'Nhận phòng',
  TOURISM_LEAVE_HOTEL: 'Trả phòng',
  arrive: 'Điểm đến',
  Room_description: 'Mô tả phòng',
  Meals: 'Bữa ăn',
  Room_Type: 'Loại phòng',
  BOOKING_EXPLANATION: 'Thông tin đặt phòng',
  BOOKING_BUTTON: 'Đặt phòng',
  REMIND_SUBMIT_ORDER: 'Tiếp tục',
  login_now: 'Để đặt phòng khách sạn cần đăng nhập, đăng nhập ngay?',
  the_real_scene: 'Hình ảnh chỉ mang tính chất tham khảo và có thể thay đổi theo thực tế.',
  Bed: 'Giường',
  Rooms: 'Phòng',
  Room_rate: 'Giá phòng',
  notified_by_SMS: 'Sau khi đặt phòng thành công, bạn sẽ nhận được thông báo qua tin nhắn SMS',
  email_notifications: 'Dùng để nhận thông báo qua email',
  Booking_deadline: 'Hạn đặt phòng',
  Child: 'Trẻ em',
  Additional_notes_about_payment: 'Ghi chú thêm về thanh toán',
  Nights: 'Đêm',
  Minimum_nights_before: 'Tối thiểu',
  Minimum_nights_after: 'đêm',
  Size: 'Kích thước',
  Guests: 'Khách',
  Room_rate_1: 'Giá phòng',
  Tax_service_fee: 'Thuế/phí dịch vụ',
  Pay_now_1: 'Thanh toán ngay',
  Filter: 'Lọc',
  Room_rate2: 'Giá phòng',
  Show_on_map: 'Hiển thị trên bản đồ',
  Detail: 'Chi tiết',
  Room_Detail: 'Chi tiết phòng',

   TAXES_INCL: 'Thuế đã bao gồm.',
  SEARCH_EMPTY_TIP: 'Xin lỗi, không có phòng trống cho ngày bạn chọn, bạn có thể: tìm kiếm ngày hoặc khách sạn khác.',
  severalNight: 'Đêm',
  immediateBooking: 'Đặt ngay',
  Refundable: 'Có thể hoàn lại',
  MORE: 'Thêm',
  adultsCompany: 'người lớn',
  ServiceTerms: 'Dịch vụ & Điều khoản',
  roomPlan: 'Kế hoạch',
  guestRoom: 'Phòng',
  searchAgain: 'Tìm kiếm lại',
  roomNight: 'phòng/đêm',

  NAME_TXT: 'Tên',
  HOLDER_NAME: 'Tên chủ thẻ',
  EXPIRATION_DATE: 'Ngày hết hạn',
  FORMAT_TXT: 'Định dạng',
  SECURITY_CODE: 'Mã bảo mật',
  MASTER_CARD_NAME: 'Master Card',
  JCB_CARD_NAME: 'JCB',
  DIGITS_ON_BACK_OF_CARD: '3 chữ số ở phía sau của thẻ.',
  AMERICAN_EXPRESS_NAME: 'American Express',
  FOUR_CAR_NUM_TIPS: '4 chữ số ở phía trước của thẻ',
  ENTER_COMPLETE_CARD_NUM: 'Vui lòng nhập đầy đủ số thẻ.',
  PLEASE_ENTER_HOLDER_NAME: 'Vui lòng nhập tên chủ thẻ',
  ENTER_SECURITY_CODE: 'Vui lòng nhập mã bảo mật',
  ENTER_EXPIRATION_DATE: 'Vui lòng nhập ngày hết hạn',
  ROOM_DETAILS: 'Chi tiết phòng',
  CONDITION_CANCEL: 'Có thể hoàn lại',
  CHOOSE_PAYMENT_METHOD: 'Thanh toán',
  ORDER_TOTAL_LUMP: 'Tổng số tiền',
  CREDIT_CARD_NUM: 'Số thẻ tín dụng/ghi nợ',
  MAINLAND_CARD_ONLY: 'Chỉ chấp nhận thẻ ngân hàng phát hành ngoài Trung Quốc đại lục.',
  SHUT_DOWN: 'Đóng',
  PROVIDER_FROM_CHINA_BANK: 'Dịch vụ thanh toán do Ngân hàng B.O.C cung cấp',

  COUPON: 'Mã giảm giá',
  APPLY_A_COUPON: 'Áp dụng mã giảm giá',
  NO_USE: 'Không áp dụng cho ưu đãi này.',
  Discard: 'Hủy',
  REDEEM: 'Sử dụng',
  EMPTY_COUPON: 'Vui lòng nhập mã khuyến mãi',
  NOTICE_COUPON: 'Chỉ có thể sử dụng một mã giảm giá cho mỗi đơn đặt phòng; mã sẽ được sử dụng sau khi đặt phòng được gửi.',

  BREAKFAST_INCLUDE: 'Bao gồm bữa sáng',
  BREAKFAST_EXCLUDE: 'Không bao gồm bữa sáng',
  DOUBLE_BED: 'Giường đôi',
  TWIN_BED: 'Giường đơn',
  FREE_CANCEL: 'Hủy miễn phí',
  MEALS: 'Bữa ăn',
  EVALUATION: 'Đánh giá',
  FEATURED_REVIEWS: 'Đánh giá nổi bật',
  ALL_REVIEWS: 'Tất cả đánh giá',
  OVERALL_EVALUATION: 'Đánh giá tổng quan',
  ANONYMOUS: 'Ẩn danh',
  EVAL_GENERAL_LIST_1: 'Kém',
  EVAL_GENERAL_LIST_2: 'Trung bình',
  EVAL_GENERAL_LIST_3: 'Trung bình khá',
  EVAL_GENERAL_LIST_4: 'Tốt',
  EVAL_GENERAL_LIST_5: 'Xuất sắc',
  MAX_IMAGES_WITH_NINE: 'Chỉ có thể chọn tối đa 9 hình ảnh.',
  GRADE_EVAL: 'Vui lòng chọn Đánh giá tổng quan',
  DISTANCE_FILTER: 'Khoảng cách gần - xa',
  EDIT_EVALUATION: 'Viết đánh giá',
  GO_TO_EVAL: 'Viết đánh giá',
  EVAL_POINTS_AWARD: 'Đánh giá tốt có thể nhận 1000 điểm, 1000 điểm = 10 RMB',
  NEARBY_LIKE_HOTEL: 'Khách sạn tương tự gần đây',
  DISTANCE_HOTEL: 'đến khách sạn',
  PLEASE_ENTER_COMMENT: 'Nhận xét',
  AWARD_POINTS_TIPS: 'Nhận xét tốt có thể nhận 1000 điểm, 1000 = 10 RMB',
  NO_SHOW_ANONYMOUS_AVATAR: 'Nhận xét ẩn danh sẽ không hiển thị logo và tên của bạn',
  LOCATION: 'Vị trí',
  FACILITY: 'Tiện nghi',
  SERVICE: 'Dịch vụ',
  HEALTH: 'Vệ sinh',
  LANGUAGE_SELECT: 'Ngôn ngữ',
  LIMIT_COMMENT_TXT: 'Đánh giá phải có từ 5 đến 2000 ký tự',
  SHARE_MEDIA: 'Chia sẻ ảnh và video',
  SETTLEMENT_FEEL: 'Nhận xét',
  SUBMIT_EVAL: 'Xác nhận',
  HOTEL_STR: 'Chi tiết',
  EVAL_NUM_AFTER: 'đánh giá',
},
header: {
  SKIING: 'Khu trượt tuyết',
  header_internal_call: 'Trung Quốc Đại lục:',
  header_abroad_call: 'Quốc tế:',
  header_app_download: 'Ứng dụng di động',
  service_telephone: 'Dịch vụ khách hàng',
  account_number: 'Tài khoản',
  if_bg_user: 'Chưa phải là thành viên BaiGolf?',
  home: 'Trang chủ',
  hotel: 'Khách sạn',
  Golf: 'Golf',
  PLAY_STAY: 'Ở & Chơi',
  RENT_CAR_HOME: 'Xe',
  center_user: 'Trung tâm thành viên',
  header_my_order: 'Đặt phòng của tôi',
  header_notmember_order: 'Đặt phòng của khách',
  header_edit_password: 'Đổi mật khẩu',
  header_logout: 'Đăng xuất',
  header_login: 'Đăng nhập',
  header_register: 'Đăng ký',
  header_point: 'Điểm của tôi',
  header_all_language: 'Tất cả các ngôn ngữ',
  down_load_app: 'Quét mã QR để tải về',
  login_discount_tip: 'Đăng nhập để nhận điểm thưởng và tận hưởng những ưu đãi độc quyền của bạn',
  currency_balance_limit: 'Đơn vị tiền tệ hiện tại vẫn còn số dư, không thể chuyển đổi tiền tệ'
},
footer: {
  footer_partner: 'Đối tác',
  footer_about_us: 'Về chúng tôi',
  footer_about_baigolf: 'Về BaiGolf.com',
  footer_privacy_policy: 'Chính sách bảo mật BaiGolf.com',
  footer_use_of_terms: 'Điều khoản Dịch vụ BaiGolf.com',
  footer_contact_us: 'Liên hệ chúng tôi',
  footer_sitemap: 'Sơ đồ trang web',
  footer_use_of_question: 'Câu hỏi thường gặp',
  footer_ios_system: 'iOS',
  footer_android_system: 'Android',
  footer_app_load: 'Tải ứng dụng',
  footer_sina_weibo: 'Sina Weibo',
  footer_tencent_weibo: 'Tencent microblog',
  footer_share_to: 'Chia sẻ',
  copyright1: 'Công ty Công nghệ Thông tin BaiGolf Guangzhou © Bản quyền ',
  copyright2: 'Yue ICP Đăng ký số 14070002',
  news_center: 'Trung tâm tin tức',
  about_baigolf: 'Về BaiGolf',
  help: 'Trợ giúp',
  management_system: 'Hệ thống quản lý Golf BG (BGMS)',
  wechat_official_account: 'Tài khoản chính thức WeChat',
  download_baiGolf_app: 'Tải ứng dụng BaiGolf',
  privacy_policy: 'Chính sách bảo mật',
  use_of_terms: 'Điều khoản Dịch vụ',
  footer_integral: 'Chính sách điểm',
  footer_reserve: 'Chính sách đặt phòng',
  footer_abroad_call: 'Quốc tế',
  footer_internal_call: 'Trung Quốc Đại lục'
  }
}



// WEBPACK FOOTER //
// ./src/lang/vietnamese.js